import { RequestError, RequestErrorType } from './generic-errors';
import { SessionDocObject } from '@aaa/emember/store-session';

export function checkOperationErrorsConnectSuiteSystem(error: SessionDocObject, obj: any) {
  throw new RequestError(RequestErrorType.MembershipError, obj);
}
